import Icon from '../../components/Icon.vue'

Icon.register({"brands/google":{"width":488,"height":512,"paths":[{"d":"M488 261.8C488 403.3 391.1 504 248 504 110.8 504 0 393.2 0 256S110.8 8 248 8C314.8 8 371 32.5 414.3 72.9L346.8 137.8C258.5 52.6 94.3 116.6 94.3 256 94.3 342.5 163.4 412.6 248 412.6 346.2 412.6 383 342.2 388.8 305.7H248V220.4H484.1C486.4 233.1 488 245.3 488 261.8z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/google.js
// module id = p3tD
// module chunks = 0